import React from "react"
import { KPIContainer } from "./Components/StyledComponent"
import { analyticsCalendarEndDate, getCurrentMonthStartAndEndDate } from "../../Helper/DatePicker/DateConverter";
import AnalyticsKPICard from "../../Features/Cards/AnalyticsKPICard";
import { getMetricInfo } from "../../Api/AlertAnalyticsApi";

function KPISection({ pagesContent }) {
  const calendarStartDate = getCurrentMonthStartAndEndDate()[0];
  const calendarEndDate = analyticsCalendarEndDate()

  return (
    <KPIContainer>
      {pagesContent?.pageMeta?.availableKPIs?.map(kpiData => <AnalyticsKPICard 
        metricName={kpiData.name} 
        startDate={calendarStartDate} 
        endDate={calendarEndDate} 
        decimalPlaces={kpiData.decimalPlaces} 
        getMetricInfo={getMetricInfo} 
      />)}
    </KPIContainer>
  )
}

export default KPISection
